
<template>
  <div class="min-h-screen flex items-center justify-center bg-blue-50 px-4">
    <div class="bg-white shadow-xl rounded-2xl p-8 max-w-md w-full text-center">
      <h2 class="text-2xl font-bold text-blue-700 mb-4">
        Bienvenue ✨
      </h2>

      <div class="mb-6 rounded-xl bg-slate-50 p-4 text-left text-sm text-slate-700">
        <p class="mb-2 font-semibold text-slate-900">
          Recevez un code pour accéder à votre espace.
        </p>
        <p>
          Sans création de compte, sans mot de passe.
        </p>
      </div>

      <form v-if="!tokenValid && !codeRequested" @submit.prevent="submitEmail" class="space-y-4">
        <input
          v-model="email"
          type="email"
          placeholder="Ton adresse e-mail"
          required
          class="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button v-if="!loading"
          type="submit"
          class="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
        >
          Envoyer le code de connexion 🚀
        </button>
        <div v-else class="mt-6 font-medium text-blue-500">Chargement...</div>
      </form>

      <form v-else-if="!tokenValid" @submit.prevent="submitCode" class="space-y-4">
        <p class="text-sm text-slate-600">
          Un code à 6 chiffres a été envoyé à <strong>{{ email }}</strong>.
        </p>
        <input
          v-model="verificationCode"
          type="text"
          inputmode="numeric"
          maxlength="6"
          placeholder="123456"
          required
          class="w-full p-3 border rounded-lg text-center tracking-[0.4em] focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button v-if="!loading"
          type="submit"
          class="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
        >
          Vérifier le code
        </button>
        <div v-else class="mt-6 font-medium text-blue-500">Chargement...</div>
        <button
          type="button"
          class="w-full text-sm text-blue-700 hover:underline"
          @click="resetFlow"
        >
          Changer d’adresse e-mail
        </button>
      </form>

      <p v-if="message && (isError || tokenValid || !codeRequested)" :class="['mb-4 font-medium', isError ? 'text-red-600' : 'text-green-600']">
        {{ message }}
      </p>

    </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {
        email: '',
        verificationCode: '',
        challengeId: '',
        message: '',
        isError: false,
        loading: true,
        tokenValid: false,  // Pour savoir si le token est valide
        codeRequested: false,
        callbackurl:'/'
      };
    },
    async mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      this.callbackurl = urlParams.get('callbackurl') || '/';
      this.loading = false; // Fin de la vérification
    },
    methods: {
      async submitEmail() {
        try {
          this.loading = true;
          this.message='';
          this.isError = false;
          console.info(`calling: ${process.env.VUE_APP_AZURE_FUNCTION_URL}/api/authenticate`)
          const response = await fetch(`${process.env.VUE_APP_AZURE_FUNCTION_URL}/api/authenticate?code=${process.env.VUE_APP_AZURE_FUNCTION_CODE}&email=${encodeURIComponent(this.email)}&callbackurl=${encodeURIComponent(this.callbackurl)}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          });
          const result = await response.json();
          if (response.ok) {
            this.challengeId = result.challengeId || '';
            this.codeRequested = true;
            this.message = result.message || 'Check your email for the verification code!';
            this.isError = false;
          } else {
            this.message = result.message || 'Failed to send verification code.';
            this.isError = true;
          }
        } catch (error) {
          this.message = `An error occurred. Please try again. ${error}`;
          this.isError = true;
        } finally{
          this.loading = false;
        }
      },
      async submitCode() {
        try {
          this.loading = true;
          this.message = '';
          this.isError = false;
          const response = await fetch(`${process.env.VUE_APP_AZURE_FUNCTION_URL}/api/authenticate?code=${process.env.VUE_APP_AZURE_FUNCTION_CODE}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              challengeId: this.challengeId,
              verificationCode: this.verificationCode.replace(/\s+/g, '')
            }),
          });
          const result = await response.json();
          if (response.ok) {
            this.tokenValid = true;
            localStorage.setItem('auth_token', result.token);
            this.message = result.message || 'Authentication successful! Redirecting...';
            this.$router.push(result.callbackurl || this.callbackurl);
          } else {
            this.message = result.message || 'Authentication failed. Please check the code.';
            this.isError = true;
          }
        } catch (error) {
          this.message = `An error occurred. Please try again. ${error}`;
          this.isError = true;
        } finally {
          this.loading = false;
        }
      },
      resetFlow() {
        this.codeRequested = false;
        this.challengeId = '';
        this.verificationCode = '';
        this.message = '';
        this.isError = false;
      }
    },
  };
  </script>
  
